import * as React from 'react';
import { Accordion, Card, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateTo } from '../../../../actions/navigationActions';
import { loadAllAddresses, createQuoteFromPolicy, initiateBuildingSteps, setStep } from '../../../../actions/salesActions';
import { refreshCart } from '../../../../actions/cartActions';
import { showCallMeModal } from '../../../../actions/modalActions';
import { BUILDING_AND_CONTENT_JOURNEY_BUILDER, DASHBOARD } from '../../../../routes/routes';
import KPBreadCrumb from '../../../KPBreadCrumb/KPBreadCrumb';
import FAQItem from '../../../FAQ/FAQItem';
import '../JourneyBuilder/JourneyBuilder.css';
import './GetBuilding.css';
import { logEvent } from '../../../../firebase/firebase';

class GetBuilding extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loggedIn: this.props.auth.uid ? true : false,
            accordionActiveKey: null,
        }

        this.handleGetQuote = this.handleGetQuote.bind(this);
    }

    componentWillMount() {
        logEvent('SSP_get_building_landed', 'user_landed_on_get_building');
    }

    async handleGetQuote() {
        logEvent('SSP_get_building_add_to_quote', 'user_cliked_get_a_quote_building');
        let nextPage = BUILDING_AND_CONTENT_JOURNEY_BUILDER;
        if (this.props.profile.policyId === "" && this.props.sales.quoteId === "") {
            await this.props.dispatchAction(initiateBuildingSteps());
            await this.props.dispatchAction(navigateTo(nextPage));
        }
        else {
            let hasAddress = (await this.props.dispatchAction(loadAllAddresses()))?.length > 0;
            if (this.props.profile.policyId !== "" && this.props.sales.quoteId === "") {
                await this.props.dispatchAction(createQuoteFromPolicy());
                if (this.props.sales.quoteId !== "") {
                    await this.props.dispatchAction(refreshCart());
                }
            }
            if (this.props.sales.quoteId !== "") {
                await this.props.dispatchAction(initiateBuildingSteps());
                await this.props.dispatchAction(setStep(3, (hasAddress ? 1 : 2)));
                await this.props.dispatchAction(navigateTo(nextPage));
            }
        }
    }

    public render() {

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]
        let faqSet = [{
            header: "What's covered by buildings insurance?",
            body: `<p class='mb-0'>Buildings insurance covers things like:
                                    <li>Your home.</li>
                                    <li>Outbuildings.</li>
                                    <li>Permanent fixtures, fittings and improvements, such as driveways, walls, garages, and fences.</li>
                                    For more info on what’s covered by the king, click <a href='/Content/documents/King-price-insurance-policy.pdf' target='_blank'><b><u>here.</b></u></a></p > `,
            id: 1
        },
        {
            header: "Are swimming pools covered by buildings insurance?",
            body: "<p class='mb-0'>Yes, swimming pools and swimming pool pumps are covered by buildings insurance!</p>",
            id: 2
        },
        {
            header: "Are carpets covered by buildings insurance?",
            body: "<p class='mb-0'>Carpets are covered by buildings insurance, as long as they’re part of your home’s immovable structures, fixtures, fittings and improvements. Loose carpets and rugs should be covered under a home contents policy and not buildings insurance.</p>",
            id: 3
        },
        {
            header: "Is it compulsory to have buildings insurance?",
            body: "<p class='mb-0'>Yes, buildings insurance is compulsory if your property is financed. Not only that, but the costs can be ceiling high and difficult to pay out of your own pocket if the worst happens.</p>",
            id: 4
        },
        {
            header: "What's the average monthly premium for buildings insurance?",
            body: "<p class='mb-0'>How much you’ll pay to insure your home is tricky to say without knowing the value of your property, and a few other details. This info goes into calculating your premium. The easiest way to find out how much you’ll pay is to get a quote from the king.</p>",
            id: 5
        },
        {
            header: "What does buildings insurance cover?",
            body: "<p class='mb-0'>Homeowners insurance, which we in the kingdom just call buildings insurance, covers the built structure of your home and its permanent fixtures and fittings against things like accidents, and damage that's caused by fire, theft and even natural disasters... Like storms.</p>",
            id: 6
        }];

        let faq;
        if (faqSet) {
            faq = faqSet.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={this.state.accordionActiveKey} />
                }
            });
        }

        return (
            <div className={"building-and-home " + (this.state.loggedIn ? "logged-in" : "logged-out")}>
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Get buildings insurance" />
                    
                <div className="building-and-home-red-banner">
                    <div className="row">
                        <div className="col-md-3 align-center sm-align-left">
                            <img src="./Images/OnlineQuotation/BuildingAndHomeContent/building-landing-page-banner-icon.svg" alt="Building Insurance" title="Building Insurance" />
                        </div>

                        <div className="col-md-5 col-lg-6">
                            <div className="building-and-home-red-banner-heading">
                                Buildings insurance
                            </div>
                            <div className="mt-2">
                                You’re the king (or queen) of your castle so make sure it’s covered.
                            </div>
                        </div>

                        <div className="col-md-4 col-lg-3 building-and-home-red-banner-get-quote align-center">
                            <button className="btn btn-solid-green btn-responsive" onClick={this.handleGetQuote}>Get a quote</button>
                        </div>
                    </div>
                </div>

                <div className="building-and-home-sub-panel">
                    <div className="building-and-home-sub-panel-heading">
                        In a nutshell
                    </div>
                    <div className="building-and-home-sub-panel-body">
                        Look, we know how valuable your castle is to you. So, if it's part of your property, we'll insure it… From geysers to gate motors to garages, from boreholes to tennis courts, from permanent structures to palisade fencing, from pools to patios, from pumps to pipes... And all the other physical things that could cost you a king's ransom to repair or replace. We offer comprehensive buildings insurance, competitive premiums and royal service. We cover loss of, or damage to, your buildings, geysers and water pipes. We also cover accidental damage to fixed glass and sanitary ware, as well as water, gas, electricity and phone connections. And, if you need to call the fire brigade, we even cover that too.
                    </div>
                </div>

                <div className="row noma">
                    <div className="col-md-6 nopa">
                        <div className="pt-4 building-and-home-sub-panel">
                            <div className="building-and-home-sub-panel-heading">
                                Insure your building for what it's worth
                            </div>
                            <div className="building-and-home-sub-panel-body mb-4">
                                A building's insured value, also known as the replacement value, should cover what it'll cost, at the time of the claim, to repair or rebuild your property from the foundations up. This amount should include the big things, like your boundary walls, solar panels and swimming pool. It should also include all the small things, like taps and tiles.
                            </div>

                            <div className="building-and-home-sub-panel-heading">
                                It’s better to over-insure than under-insure
                            </div>
                            <div className="building-and-home-sub-panel-body">
                                We pay buildings insurance claims by subtracting your excess and any dual or under-insurance from your insured value. So, your replacement value should be realistic. If in doubt, over-insure, or call in a pro for a proper valuation… Because, if you're under-insured, we'll only pay a pro rata amount. And we don't want that to happen!
                            </div>
                         </div>
                    </div>

                    <div className="col-md-6 nopa">
                        <Card className="building-and-home-sub-panel ml-7px">
                            <div className="building-and-home-sub-panel-heading">
                                FAQs
                            </div>
                            <div className="new-ssp-code-red-faq-block code-red-accordion-holder">
                                <Accordion className="" onSelect={(e) => this.setState({ accordionActiveKey: Number(e) })}>
                                    {faq}
                                </Accordion>
                            </div>
                        </Card>
                    </div>
                </div>
                <div className="row d-md-none">
                    <div className="col btn-solid-green footer-button justify-content-center" onClick={this.handleGetQuote}>
                        Get a quote
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GetBuilding);